<!-- 数据字典 Select 选择器 -->
<template>
  <ElSelect v-if="selectType === 'select'" class="w-1/1" v-bind="attrs">
    <ElOption
      v-for="(dict, index) in getDictOptions"
      :key="index"
      :label="dict.label"
      :value="dict.value"
    />
  </ElSelect>
  <el-radio-group v-if="selectType === 'radio'" class="w-1/1" v-bind="attrs">
    <el-radio v-for="(dict, index) in getDictOptions" :key="index" :value="dict.value">
      {{ dict.label }}
    </el-radio>
  </el-radio-group>
  <el-checkbox-group v-if="selectType === 'checkbox'" class="w-1/1" v-bind="attrs">
    <el-checkbox
      v-for="(dict, index) in getDictOptions"
      :key="index"
      :label="dict.label"
      :value="dict.value"
    />
  </el-checkbox-group>
</template>

<script lang="ts" setup name="DictSelect">
import { getDictionarySelectList } from '@/api/dictionaryManagement'
import { computed, useAttrs, ref, unref } from 'vue'
import { ElSelect, ElOption } from 'element-plus'

const dictList = ref<any[]>([])
const getSelectLsit = async () => {
  const res = await getDictionarySelectList()
  dictList.value =
    res?.data?.map((item) => ({
      label: item.dictName,
      value: item.dictType
    })) ?? []
}
getSelectLsit()

defineOptions({
  name: 'DictSelect'
})

const attrs = useAttrs()

// 接受父组件参数
interface Props {
  dictType?: string // 字典类型
  valueType?: 'str' | 'int' | 'bool' // 字典值类型
  selectType?: 'select' | 'radio' | 'checkbox' // 选择器类型，下拉框 select、多选框 checkbox、单选框 radio
  formCreateInject?: any
}

const props = withDefaults(defineProps<Props>(), {
  valueType: 'str',
  selectType: 'select'
})

// 获得字典配置
const getDictOptions = computed(() => {
  switch (props.valueType) {
    case 'str':
      return unref(dictList)
    case 'int':
      return unref(dictList)
    case 'bool':
      return unref(dictList)
    default:
      return []
  }
})
</script>
